module.exports = __webpack_public_path__ + "static/media/ro.ba283802.svg";